//WE.Flow.Html.Contracts.Manifests.ProductConfigManifest
import { ComponentManifest } from "./ComponentManifest";

export class ProductConfigManifest {
    cacheBuster: string = "";
    customOptionsComponent: ComponentManifest = null;
    hide: boolean = false;
    inactiveReason: string = "";
    metaConfig: any = null;
}
